import {createSelector} from 'reselect';

const selectReports = (state) => state.reports;

const makeSelectReportsData = () =>
    createSelector(selectReports, (data) => ({
        ...data,
    }));

const makeSelectReportTypes = () => createSelector(selectReports, (reportsState) => reportsState.reportTypes);
const makeSelectDeviceGroupTypes = () => createSelector(selectReports, (reportsState) => reportsState.deviceTypesGroup);

export {makeSelectReportsData, makeSelectReportTypes, makeSelectDeviceGroupTypes};
